import { useQuery } from '@tanstack/react-query';
import { fetchYoutubeLiveStreamVideos } from '../../utils/react-query/query-functions';
import { QUERY_KEYS } from '../../utils/react-query/query-keys';
import { ExtractFnReturnType } from '../../utils/react-query/react-query';

export const useYoutubeLiveStreamVideos = () => {
  const STALE_TIME = 60 * 1000;
  return useQuery<ExtractFnReturnType<typeof fetchYoutubeLiveStreamVideos>>({
    queryKey: QUERY_KEYS.YOUTUBE.LIVE_STREAM_VIDEOS,
    queryFn: fetchYoutubeLiveStreamVideos,
    staleTime: STALE_TIME,
    refetchInterval: STALE_TIME,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
